import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { SimpleUser } from 'app/models';
import { CommentApi } from 'app/modules/dashboard/api/comment.api';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { CommentElementComponent } from '../comment-element/comment-element.component';

@Component({
  selector: 'app-comment-block',
  templateUrl: './comment-block.component.html',
  styleUrls: ['./comment-block.component.scss'],
  standalone: true,
  imports: [CommentElementComponent, NgIf, NgFor, SkeletonModule, AsyncPipe],
})
export class CommentBlockComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  @Input() comment!: any;
  @Input() user: SimpleUser = null;
  @Input() videoCommentId: number = 0;
  @Input() isActionClick: boolean;
  @Input() focusComment: boolean;
  @Input() commentType: 'watch' | 'coaching';

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onMoreClick: EventEmitter<number>;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSubMoreClick: EventEmitter<number>;
  @Output() subCommentsCountEvent: EventEmitter<number>;
  @Output() deleteCommentElement: EventEmitter<number>;

  replyCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  subComments$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  subCommmentLoading$ = new BehaviorSubject<boolean>(false);

  displaySubComment: boolean = false;

  constructor(private commentApi: CommentApi) {
    this.onMoreClick = new EventEmitter<number>(null);
    this.onSubMoreClick = new EventEmitter<number>(null);
    this.deleteCommentElement = new EventEmitter<number>(null);
    this.subCommentsCountEvent = new EventEmitter<number>(null);
  }

  getSubComment(event: boolean) {
    this.displaySubComment = event;
    if (this.subComments$.getValue().length === 0 && event) {
      this.subCommmentLoading$.next(true);
      this.subscriptions = [
        ...this.subscriptions,
        this.commentApi.getSubComments(this.comment.id).subscribe((res) => {
          this.subCommmentLoading$.next(false);
          this.subComments$.next(res);
        }),
      ];
    }
  }

  addNewSubComment(comment: any) {
    if (comment !== null) {
      this.subComments$.next([comment, ...this.subComments$.getValue()]);
      this.subCommentsCountEvent.emit(1);
    }
  }

  deleteComment(event: any) {
    if (
      event.isSubComment &&
      this.subComments$.getValue().find((el) => el.id === event.commentId) !==
      undefined
    ) {
      this.commentApi
        .deleteVideo(this.videoCommentId, event.commentId)
        .pipe(take(1))
        .subscribe(() => {
          const updatedSubComments = this.subComments$
            .getValue()
            .filter((el) => el.id !== event.commentId);
          this.subComments$.next(updatedSubComments);
          this.replyCount.next(this.replyCount.getValue() - 1);
        });
    } else {
      this.deleteCommentElement.emit(event.commentId);
    }
  }

  onMoreActionClick() {
    this.onMoreClick.emit(this.comment.id);
  }

  onSubMoreActionClick() {
    this.onSubMoreClick.emit(this.comment.id);
  }

  ngOnInit(): void {
    this.replyCount.next(this.comment.reply_count);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
